import { COLORS } from '../../../../shared/config/colors/colors';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    padding: 20px;
    gap: 20px;
    border-radius: 16px;
    border: 1px solid ${COLORS.neutral_10};
    background-color: ${COLORS.neutral_00};
    align-items: flex-start;
`;

const Cell = styled('div')`
    display: flex;
    flex-direction: column;
`;

export const Indicator = styled('div')`
    display: flex;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    background-color: ${COLORS.primary_20};

    &::before {
        content: '';
        display: block;
        width: 50%;
        height: 50%;
        border-radius: 50%;
        background-color: ${COLORS.primary_60};
    }
`;

export const StatusCell = styled(Cell)``;

export const DateCell = styled(Cell)`
    width: 55px;
    gap: 4px;
`;

export const ProductCell = styled(Cell)`
    flex-grow: 1;
    gap: 4px;
`;

export const ControlsCell = styled('div')`
    display: flex;
    gap: 8px;
    align-self: center;
    align-items: center;
`;
